import api from "./utils";

const getSubreddits = async (params) => {

  // return await api.get(`/reddit/crawl/results?page=${page}&sort_by=${sort_by}&sort_direction=${sort_direction}&search=${search}`).then((results) => results.data);
  return await api.get(`/reddit/crawl/results`,{params}).then((results) => results.data);
};

const crawlSubreddit = async (data) => {
  return await api
    .post("/reddit/crawl/start", data)
    .then((results) => results.data);
};

const getRedditTasks = async (data) => {
  return await api.get("/reddit/crawl/tasks").then((results) => results.data);
};

const killRedditTask = async (subreddit_id) => {
  return await api.post('/reddit/crawl/stop',subreddit_id).then(results => results.data)
}

const deleteRedditTask = async (subreddit) => {
  return await api.delete(`/reddit/crawl/tasks/delete/${subreddit.subreddit}`)
}

export { getSubreddits, crawlSubreddit, getRedditTasks, killRedditTask, deleteRedditTask };
